import React from "react";
import pmgsHipTag from "./../../assets/PM GATISHAKTI NPG.svg";

export const PmgsHipimage = ({ className, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={pmgsHipTag} />
    </div>
  ) : null;
};
